import { useState } from "react";
import { post } from "../../lib/sessionClient";

const useUploadSheet = () => {
  const [loading, setLoading] = useState(false);
  const [isSucceed, setIsSucceed] = useState(false);
  const [formError, setFormError] = useState(false);
  const [formErrMsg, setFormErrMsg] = useState("");
  const [responseData, setResponseData] = useState();
  const [errorResponse, setErrorResponse] = useState(undefined);
  const [isErrorSheetList, setErrorSheetList] = useState(false);

  const executePost = async (sendData, apiUrl, updateStateOnResponse) => {
    setLoading(true);
    try {
      const response = await post(apiUrl, sendData);
      setResponseData(response.data);
      if (
        response.data.sheetErrorCount &&
        response.data.sheetErrorCount !== 0
      ) {
        setErrorSheetList(true);
      } else {
        updateStateOnResponse();
        setIsSucceed(true);
      }
    } catch (error) {
      setFormError(true);
      setFormErrMsg(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      );
      setErrorResponse(
        error.response?.data ? error.response.data : error.message
      );
    } finally {
      setLoading(false);
    }
  };

  return {
    executePost,
    loading,
    isSucceed,
    formError,
    formErrMsg,
    responseData,
    setIsSucceed,
    setFormError,
    setResponseData,
    errorResponse,
    isErrorSheetList,
    setErrorSheetList,
  };
};

export default useUploadSheet;
